export default __webpack_public_path__ + "static/media/saw-1.c21b6100.png";